import { useParams } from 'react-router';
import StaticDoc from '../components/static-docs/StaticDoc';

const APIDoc = () => {
  const { docName } = useParams();
  if (!docName) {
    return <div>Loading now</div>;
  }
  return <StaticDoc fileName={'./' + docName} />;
};

export default APIDoc;
